import React, { useState } from "react";
import styles from "./FAQ.module.scss";
import closeIcon from "../assets/images/x-close.svg";
import caretIcon from "../assets/images/caret-down.svg";

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.faqItem}>
      <button className="paragraph-default" onClick={() => setIsOpen(!isOpen)}>
        <span className="question">{question}</span>
        <img
          src={caretIcon}
          className={
            isOpen
              ? `${styles.expandIcon} ${styles.open}`
              : `${styles.expandIcon}`
          }
          alt="close"
        />
      </button>
      {isOpen && <p className="paragraph-small">{answer}</p>}
    </div>
  );
};

const FAQ = ({ onClose }) => {
  const faqItems = [
    {
      question: "What is AI-Mapping?",
      answer:
        "AI-Mapping is the next generation of indoor mapping, allowing indoor maps to be built at scale. Pointr's MapScale® uses deep learning and large language models (LLM) to automatically produce accurate digital maps from floor-plans, eliminating the need for any human / manual work.",
    },
    {
      question: "What file formats are supported?",
      answer:
        "For this demo, we only support DWG or DXF files. In production, MapScale® API also supports Vector PDFs and GeoJSONs as input too but these are not supported in this website demo at this time.",
    },
    {
      question: "Why is there a file size limit?",
      answer:
        "As this a free demo, we limited the size to avoid extra load on the server. Larger size files are supported in Production."
    },
    {
      question: "How long does the mapping process take?",
      answer:
        "The mapping process typically takes 15-30 minutes per floor-plan, depending on the size and complexity of your floor-plan.",
    },
    {
      question: "When will other building types become available?",
      answer:
        "More building types (such as Retail) are available in Production but we are releasing building types gradually for this demo. Our next major update is scheduled for January 2025.",
    },
    {
      question: "Is my data secure?",
      answer:
        "Yes, we take data security very seriously. All uploaded files and generated maps are encrypted and stored securely. We do not share your data with third parties.",
    },
    {
      question: "Can I edit the generated map?",
      answer:
        "Yes. Once a map is produced, it can be edited using Pointr Cloud CMS. However, this requires a commercial license. Get in touch with our team at contact@pointr.tech to obtain a license.",
    },
    {
      question: "How can I contact support?",
      answer:
        "You can email mapscale-support@pointr.tech",
    },
  ];

  const onClickOverlay = (event) => {
    onClose();
  };

  const onClickContent = (event) => {
    event.stopPropagation();
  };

  return (
    <div id="faq" className="overlay" onClick={onClickOverlay}>
      <div id={styles.faqContent} onClick={onClickContent}>
        <h2>Frequently Asked Questions</h2>
        <button className={styles.closeIcon} onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </button>
        {faqItems.map((item, index) => (
          <FAQItem key={index} question={item.question} answer={item.answer} />
        ))}
      </div>
    </div>
  );
};

export default FAQ;
